import { Logo } from './Logo';
import { NAV_LINKS } from '../data/navigation';
import { APP_LINKS } from '../data/appLinks';
import { PageLink, ROUTES, sectionHref } from '../router';
import './SiteFooter.css';

const SOCIAL_LINKS = [
  { label: 'Instagram', href: 'https://www.instagram.com/drivetulink/' },
  { label: 'X / Twitter', href: 'https://x.com/drivetulink' },
  { label: 'TikTok', href: 'https://www.tiktok.com/@drivetulink' },
];

export const SiteFooter = ({ onOpenCredits, route = ROUTES.home }) => {
  return (
    <footer className="tl-footer tl-surface-dark">
      <div className="tl-shell">
        <div className="tl-footer__grid">
          <div className="tl-footer__brand">
            <Logo variant="reversed" width={156} alt="Tu-Link" />
            <p className="tl-footer__description">
              Tulink helps groups stay connected and arrive together.
            </p>
          </div>

          <nav className="tl-footer__column" aria-label="Footer">
            <h2 className="tl-footer__heading">Explore</h2>
            <ul>
              {NAV_LINKS.map((link) => (
                <li key={link.href}>
                  <a className="tl-footer__link" href={sectionHref(link.href, route)}>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div className="tl-footer__column">
            <h2 className="tl-footer__heading">More</h2>
            <ul>
              <li>
                <a
                  className="tl-footer__link"
                  href={APP_LINKS.ios}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Get iOS
                </a>
              </li>
              <li>
                <PageLink className="tl-footer__link" to={APP_LINKS.android}>
                  Get Android
                </PageLink>
              </li>
              <li>
                <PageLink className="tl-footer__link" to={ROUTES.teamGuide}>
                  Guide: add your team
                </PageLink>
              </li>
              <li>
                <button
                  type="button"
                  className="tl-footer__link tl-footer__button"
                  onClick={onOpenCredits}
                >
                  Photo credits
                </button>
              </li>
              {SOCIAL_LINKS.map((link) => (
                <li key={link.href}>
                  <a
                    className="tl-footer__link"
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/*
          These two links are release requirements, not decoration: Google Play
          expects the policy to be labelled "Privacy Policy" in full, and the
          deletion route to be reachable from the site without signing in. They
          stay in the footer proper rather than behind the mobile menu.
        */}
        <div className="tl-footer__legal">
          <p className="tl-footer__copyright">© 2026 Tu-Link. All rights reserved.</p>
          <nav aria-label="Legal">
            <ul className="tl-footer__legal-links">
              <li>
                <PageLink className="tl-footer__link" to={ROUTES.privacy}>
                  Privacy Policy
                </PageLink>
              </li>
              <li>
                <PageLink className="tl-footer__link" to={ROUTES.deleteAccount}>
                  Delete your account
                </PageLink>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </footer>
  );
};
